// Extended formatting helpers layered on the existing format module.
import { formatDistanceToNowStrict, parseISO } from 'date-fns';
export { SEVERITY_META, CATEGORY_META, ZONE_META, fmtDate, fmtRel, fmtCoord, fmtPct, classNames } from './format';

export const OBSERVATION_STAGE_META = {
  'AI Observation': { color: '#64748B', hint: 'AI-generated observation awaiting analyst review' },
  'Under Analyst Review': { color: '#3B82F6', hint: 'Analyst reviewing AI observation' },
  'Probable Alert': { color: '#F59E0B', hint: 'Analyst assessed as probable' },
  'Validated Alert': { color: '#F97316', hint: 'Analyst validated; alert issued' },
  'Field Verification Required': { color: '#8B5CF6', hint: 'Site inspection requested' },
  'Confirmed Incident': { color: '#EF4444', hint: 'Field-verified incident under action' },
  'Resolved': { color: '#22C55E', hint: 'Resolution recorded' },
  'Closed': { color: '#64748B', hint: 'Incident closed' },
};

export const EVIDENCE_META = {
  Strong: { color: '#16A34A', hint: 'Clear before/after change, adequate area & confidence' },
  Moderate: { color: '#F59E0B', hint: 'Change visible, moderate area or confidence' },
  Limited: { color: '#F97316', hint: 'Marginal change or low confidence' },
  Insufficient: { color: '#EF4444', hint: 'Not enough evidence to act on' },
};

export function fmtDistance(m) {
  if (m === null || m === undefined) return '—';
  if (m < 1000) return `${Math.round(m)} m`;
  return `${(m / 1000).toFixed(2)} km`;
}

export function fmtFreshness(iso) {
  if (!iso) return { label: 'no data', tone: 'muted' };
  try {
    const d = typeof iso === 'string' ? parseISO(iso) : iso;
    const rel = formatDistanceToNowStrict(d);
    const hours = (Date.now() - d.getTime()) / 36e5;
    let tone = 'ok';
    if (hours > 24 * 30) tone = 'muted';
    else if (hours > 24 * 7) tone = 'warn';
    return { label: `${rel} ago`, tone };
  } catch { return { label: 'unknown', tone: 'muted' }; }
}
